import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import { formatDateTime } from "../../helpers/helpers";

export default function FinanceiroEnvioEmails(props) {
  const [faturaEnvioEmailId] = useState(Number(props.match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [email, setEmail] = useState({});

  useEffect(() => {
    carregar();
  }, [faturaEnvioEmailId]);

  const carregar = () => {
    setCarregando(true);

    api
      .get("faturas/carregarEnvioEmail", {
        faturaEnvioEmailId: faturaEnvioEmailId,
      })
      .then((res) => {
        setEmail(res);
        setCarregando(false);
      });
  };

  const fDados = {
    title: "Email enviado",
    form: {
      componente: {
        type: "component",
        value: (
          <div>
            <h4>Fatura</h4>
            <a
              href={`${window.location.origin}/app/faturas/fatura-escola/${email.escolaId}/${email.faturaVencimentoAno}/${email.faturaVencimentoMes}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {email.faturaVencimentoMes}/{email.faturaVencimentoAno}
            </a>
          </div>
        ),
        space: 6,
      },
      escola: {
        type: "text",
        label: "Escola",
        readOnly: "true",
        value: email.escolaNomeFantasia,
        space: 6,
      },
      faturaEnvioEmailEnvio: {
        type: "text",
        label: "Envio",
        readOnly: "true",
        value: formatDateTime(email.faturaEnvioEmailEnvio, "D/M/Y h:m"),
        space: 6,
      },
      faturaEnvioEmailDestinatario: {
        type: "text",
        label: "Destinário",
        readOnly: "true",
        value: email.faturaEnvioEmailDestinatario,
        space: 6,
      },
      faturaEnvioEmailMensagem: {
        type: "component",
        value: (
          <div>
            <h4>Mensagem</h4>
            <div
              style={{ background: "#fffccc", padding: 10, borderRadius: 10 }}
              dangerouslySetInnerHTML={{
                __html: email.faturaEnvioEmailMensagem,
              }}
            ></div>
          </div>
        ),
      },
      faturaEnvioEmailErro: {
        type: "text",
        label: "Situação do envio",
        readOnly: "true",
        value: !email.faturaEnvioEmailErro
          ? "Enviado com sucesso"
          : email.faturaEnvioEmailErro,
        space: 12,
      },
    },
  };

  return (
    <div>{carregando ? <CircularProgress /> : <Form formData={fDados} />}</div>
  );
}
